<template>
  <div
    :class="{
      female: person.Sex
        ? person.Sex !== null && person.Sex.indexOf('女') !== -1
        : null,
      ban: person.BlacklistReason,
    }"
  >
    <div style="position: relative" class="card-inner">
      <div class="basic-info">
        <div class="img-wrap">
          <template>
            <el-tooltip
              v-if="person.BlacklistReason"
              class="item"
              effect="light"
              :content="person.BlacklistReason"
              placement="top"
            >
              <el-image
                :src="
                  person.HeadPhotoBase64 === null
                    ? require(`@/assets/img/head2.png`)
                    : person.HeadPhotoBase64
                "
                :preview-src-list="person.HeadPhotoBase64 === null ? null : [person.HeadPhotoBase64]"
                alt="大頭照"
              />
            </el-tooltip>
            <el-image
              v-else
              :src="
                person.HeadPhotoBase64 === null
                  ? require(`@/assets/img/head2.png`)
                  : person.HeadPhotoBase64
              "
              :preview-src-list="person.HeadPhotoBase64 === null ? null : [person.HeadPhotoBase64]"
              alt="大頭照"
            />
          </template>
        </div>

        <div class="info">
          <slot name="tag" :props="person" />

          <div class="note">
            <slot name="note" :props="person" />
          </div>

          <div class="name">
            {{ person.Name }}
            <template v-if="person.Age">
              <span v-if="person.Age !== 121" class="age">
                {{ person.Age }} 歲
              </span>
            </template>
          </div>

          <div class="email">{{ person.Email }}</div>
        </div>
      </div>
      <label v-if="showCheckbox" class="check-wrap">
        <input
          type="checkbox"
          :checked="person.isChecked"
          v-model="person.isChecked"
          @click="clickCheck(person)"
        />
        <span>
          <i class="fas fa-check"></i>
        </span>
      </label>
      <div class="detail-info">
        <slot name="middleContent" :props="person"></slot>
      </div>
      <div class="file-info">
        <slot name="buttonGroup" :props="person"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["person", "showCheckbox"],

  name: "PersonCard",
  data() {
    return {
      choosePerson: [],
    };
  },

  filters: {
    moment: function (date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },

  methods: {
    clickCheck(person) {
      const Person = [
        {
          ResumeType: person.ResumeType,
          ResumeId: person.ResumeId,
          MatchId: person.MatchId,
          Email: person.Email,
          ApprovalResult: person.ApprovalResult
        },
      ];
      this.$emit("updatePersonList", Person);
    },
  },
};
</script>
